import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest, debounceTime, delay, filter, map, merge, Observable, startWith, Subject, take, takeUntil, tap } from 'rxjs';

// libs
import { MapGeocoder  } from '@angular/google-maps';

// enums
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { usersType } from 'src/app/core/enums/user/user-type';
import { Price_Type } from 'src/app/core/enums/ads/price-types';
import { FILE_TYPE } from 'src/app/core/enums/global/files-types';
import { Contract_Type } from 'src/app/core/enums/ads/contract-types';
import { CRUD_COMPONENT } from 'src/app/core/enums/global/crud-types';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';
import { PAYMENT_TYPE } from 'src/app/core/enums/payment/payment-types';
import { FEATURES_TYPE } from 'src/app/core/enums/features/features-type';
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';
import { AD_CONFIG_SERVICE_TYPE } from 'src/app/main.components/Ads-management/services/ad-configuration/enums/ad-configuration-service-type';

// interfaces
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IArea } from 'src/app/core/interfaces/location/area';
import { PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { ICity } from 'src/app/core/interfaces/location/city';
import { ICompany } from 'src/app/core/interfaces/ads/companies';
import { IRegion } from 'src/app/core/interfaces/location/region';
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';
import { ICategory } from 'src/app/core/interfaces/category/category';
import { ADVERTISEMENT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { IBillInfo } from 'src/app/core/interfaces/ads/ads-bill-info';
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';
import { IPaymentPlan } from 'src/app/core/interfaces/ads/payment-plan';
import { ISettingsResponse } from 'src/app/core/interfaces/app/settings';
import { IAdvertisementOperation } from 'src/app/core/interfaces/ads/advertisement';
import { IMetaDataAdvertisement } from 'src/app/core/interfaces/payment/meta-data-advertisement';

// services
import { LoaderService } from 'src/app/core/services/loader.service';
import { GlobleService } from 'src/app/core/services/globle.service';
import { AuthService } from 'src/app/core/services/user/auth.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';
import { IhttpError } from 'src/app/core/interfaces/http-response/http-error';
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';
import { TopLevelSingleService } from 'src/app/core/services/single-api-top-level-app/singel-top-level.service';
import { AD_CONFIG_SERVICE_TYPE_TOKEN, AdConfigurationService } from 'src/app/main.components/Ads-management/services/ad-configuration/ad-configuration.service';

// validations
import AdsValidators from 'src/app/core/validations/ads/ads-validators';
import OverrideValidators from 'src/app/core/validations/validators-override/validators-override';

// static
import { listOfRentType } from 'src/app/core/reusable-objects/globle-objs/rent-list';
import { ListOfContractType } from 'src/app/core/reusable-objects/globle-objs/contract-list';

// classes
import { HttpErrorResponseHandler } from 'src/app/core/classes/http-error-response-handler';

// custom animations
import { fade } from 'src/app/core/animations/fade';

// built in interface
interface IRouteData {
  type: PRODUCT_TYPE
  label: string
  title: string
  vipAds: boolean 
  curd: CRUD_COMPONENT
  banks?: any[],
  regions: IRegion[],
  companies: ICompany[]
  saleServices?: any[],  
  categories: ICategory[],          
  bundledAdFullEdit?: boolean
  paymentPlans: IPaymentPlan[]
}

// declare var google: any;

@Component({
  selector: 'app-add-ads',
  templateUrl: './build-ads.component.html',
  styleUrls: ['./build-ads.component.scss'],
  animations: [fade],
  providers: [
    AdConfigurationService,
    { provide: AD_CONFIG_SERVICE_TYPE_TOKEN, useValue: AD_CONFIG_SERVICE_TYPE.advertisement }
  ]  
})
export class buildAdsComponent implements OnInit, OnDestroy {
  
  /**
   * fields
   */

  /**
   * @description that data get from rega
   * @deprecated all data will store in adData filed
   */
  public RegaData: IRega = null;  

  /**
   * @description if true the advertiser-class  component will show
   */
  public ShowAdvertiserClass: boolean = true;

  /**
   * @description if true that mean the ad data is Depends on rega Data, else that mean the ad data is Depends on user to select data manually
   */
  public RegaMode: boolean = false;

  /**
   * @description those controls will be disabled for doesn't user interaction,
   * but before Submission the form to server,
   * will enabled it's to access it in From value property
   */
  private disabledControlsEligibleForSubmission: string[] = [];

  /**
   * @description get response from http request
   */
  public ResponseAdData: {[key: string]: any} | null = null;

  /**
   * @description get Error response from http request
   */
  public ErrorsResponse: IhttpError['errors'] = null;

  /**
   * @description to get bill Info if current User is not Office
   */
  public BillInfo: IBillInfo = null;

  /**
   * @description metaData payment
   */
  public MetaData: IMetaDataAdvertisement

  /**
   * @description if true navigate to tapPayment
   */
  public NavigateToTapPayment: boolean = false;

  /**
   * 
   */
  public PaymentTypeAd = PAYMENT_TYPE.ads

  /**
   * @description if ( true ) popup map ui will show, else will hide
   * @returns boolean value
   */
  public PopupMap: boolean = false;

  /**
   * @description we have to much subscriptions in this component, then we will pass this field to takeUnit operator to unSubscript from any Observable
   * and emit it inside ngOnDestroy component
   */
  private _destroy$ = new Subject<void>(); 


  /**
   * @description create array from 50 length
   */
  public Floors: number[] = Array.from({ length: 50 }, (_, i) => i + 1);

  /**
   * @description loading for LiveSearch http request
   * @returns boolean value
   */
  public isLoadingLiveSearch: boolean = false;  

  /**
   * @description loading for Geocoder http request
   * @returns boolean value
   */
  public isLoadingGeocoder: boolean = false;

  /**
   * @description to give google map center position
   * @returns lat & lng
   */
  public MapCoords: google.maps.LatLngLiteral = null

  /**
   * @description google map object
   * @returns google.maps.Map
   */
  public Map: google.maps.Map = null

  /**
   * to get current location Address in map
   * @returns area or place name
   */
  public CurrentMapAddress: string = null;

  /**
   * google map Option
   */
  public googleMapsOptions: google.maps.MapOptions = {
    zoom: 15,
    scrollwheel: false,
    mapTypeControl: true,
    fullscreenControl: true
  }   

  /**
   * 
   */
  constructor(
    private readonly _router: Router,
    private readonly _fb: FormBuilder,
    private readonly _g: GlobleService,
    private readonly _auth: AuthService,
    private readonly _alert: AlertService,
    private readonly _route: ActivatedRoute,
    private readonly _geocoder: MapGeocoder,
    private readonly _loader: LoaderService,
    private readonly _api: ApiResponseService,
    private readonly _top_api: TopLevelSingleService,
    private readonly _adOperation: AdOperationService,
    private readonly _adConfigService: AdConfigurationService,
  ) {}

  /**
   * Getters & Setters
   */

  /**
   * userInfo
   */
  public get UserInfo(): BehaviorSubject<IUserInfo > {
    return this._auth.userInfo;
  }

  /**
   * USER_TYPES
   */
  public get USER_TYPES(): typeof usersType {
    return usersType
  }

  /**
   * routeData
   */
  public get routeData(): Observable<IRouteData> {
    return this._route.data as any
  }

  /**
   * 
   */
  public get IsLoading(): boolean {
    return this._adConfigService.IsLoading
  }

  /**
   * 
   */
  public set IsLoading(value: boolean) {
    this._adConfigService.IsLoading = value
  }

  /**
   * 
   */
  public get PreviewCurrentFormData() {
    return this._adConfigService.PreviewCurrentFormData
  }

  /**
   * @description if component in update mode or rega Mode, getter will return current ad Data else return null
   * @returns ad Data or null
   */
  private get _adData(): {[key: string]: any} | null {
  
    return this._adConfigService.adData

  }
  private set _adData(data: {[key: string]: any}) {
    this._adConfigService.adData = data;
  }

  /**
   * check operation mode
   */
  public get isOperationCreatedMode(): boolean {
    return this._route.snapshot.data.curd == CRUD_COMPONENT.create;
  }

  /**
   * Setting
   */
  public get Setting(): Observable<ISettingsResponse> {
    return this._top_api.Setting$
  }

  /**
   * 
   */
  public get Form(): FormGroup {
    return this._adConfigService.Form
  }

  /**
   * Regions
   */
  public get Regions(): IRegion[] {
    return this._route.snapshot.data.regions
  }

  /**
   *Cities
   */
   public get Cities(): ICity[] {
    return this._adConfigService.Cities
  }

  /**
   * IsLoadingCities
   */
  public get IsLoadingCities(): boolean {
    return this._adConfigService.IsLoadingCities
  } 

  /**
   *Areas
   */
   public get Areas(): IArea[] {
    return this._adConfigService.Areas
  }

  /**
   * IsLoadingAreas
   */
  public get IsLoadingAreas(): boolean {
    return this._adConfigService.IsLoadingAreas
  }

  /**
   * Categories
   */
  public get Categories(): ICategory[] {
    return this._route.snapshot.data.categories
  }
  
  public get FilteredCategories(): ICategory[] {
    return this.Categories
  }

  public set FilteredCategories(value: ICategory[]) {
    this._route.snapshot.data.categories = value
  }  

  /**
   * SubCatagories
   */
  public get SubCatagories(): ICategory[] {
    return this._adConfigService.SubCatagories
  }

  /**
   * _mainProperties
   */
  public get MainProperties(): any[] {
    return this._adConfigService.MainProperties
  }  

  /**
   * MainPropertiesControl
   */
  public get MainPropertiesControl(): AbstractControl[] {
    return this._adConfigService.MainPropertiesControl.controls
  }
  
  /**
   * _subProperties
   */
  public get SubProperties(): any[] {
    return this._adConfigService.SubProperties
  }

  /**
   * SubPropertiesControl
   */
  public get SubPropertiesControl(): AbstractControl[] {
    return this._adConfigService.SubPropertiesControl.controls
  }

  /**
   * IsLoadingProperties
   */
  public get IsLoadingProperties(): boolean {
    return this._adConfigService.IsLoadingProperties;
  }

  /**
   * UnitsControls
   */
  public get UnitsControl(): FormArray {
    return (this.control('units') as FormArray);
  }

  /**
   * UnitsControls
   */
  public get ZonesControl(): FormArray {
    return (this.control('zones') as FormArray);
  }  

  /**
   * @description will has liveSearch result for type ad Building
   */
  public get filteredUnits$() {
    return this._adConfigService.filteredUnits$
  }

  /**
   * @description will has liveSearch result for type ad Building
   */
  public get Units() {
    return this._adConfigService.Units;
  }

  /**
   * @description will has liveSearch result for type Planing
   */
  public get Lands() {
    return this._adConfigService.Lands;
  }  

  /**
   * @description will has liveSearch result for type Villas
   */
  public get Villas() {
    return this._adConfigService.Villas;
  } 
  
  /**
   * @description will has liveSearch result for type Villas
   */
  public get Buildings() {
    return this._adConfigService.Buildings;
  }   

  /**
   * featuresType
   */
  public get FeaturesType(): typeof FEATURES_TYPE {
    return FEATURES_TYPE
  }  
  
  /**
   * ControlLabelValueType
   */
  public get ControlLabelValueType(): typeof this._adConfigService.ControlLabelValueType {
    return this._adConfigService.ControlLabelValueType
  }

  /**
   * CategoryType
   */
  public get _categoryType(): CATEGOR_VALUE_TYPE {
    return this._adConfigService.CategoryType
  }

  /**
   * AdvertisementType
   */
  private get _advertisementType(): ADVERTISEMENT_TYPE {
    return this.control('type').value
  }  
  
  /**
   * IsAdvertisementOffPlanSale
   */
  public get IsAdvertisementTypeOffPlanSale(): boolean {
    return this._advertisementType === ADVERTISEMENT_TYPE.offPlanSale
  }  

  /**
   * Banks
   */
  public get Banks(): any[] {
    
    // ES6 Destructuring 
    const { banks } = this._route.snapshot.data;

    /**
     * 
     */
    if (banks !== null && Array.isArray(banks)) return banks

    /**
     * 
     */
    return [];

  }

  /**
   * BanksControls
   */
  public get BanksControls(): AbstractControl[] {
    return (this.control('banks') as FormArray).controls || []
  }    

  /**
   * SaleServices
   */
  public get SaleServices(): any[] {
    
    // ES6 Destructuring 
    const { saleServices } = this._route.snapshot.data;

    /**
     * 
     */
    if (saleServices !== null && Array.isArray(saleServices)) return saleServices

    /**
     * 
     */
    return [];

  }

  /**
   * SaleServicesControls
   */
  public get SaleServicesControls(): AbstractControl[] {
    return (this.control('services') as FormArray).controls || []
  }

  /**
   * ADVERTISEMENT_TYPE
   */
  public get ADVERTISEMENT_TYPE(): typeof ADVERTISEMENT_TYPE {
    return ADVERTISEMENT_TYPE
  }
  
  /**
   * @description for Companies supported or sponsors fro that ad
   */
  public get Companies(): ICompany[] {
    return this._adConfigService.Companies;
  } 
  
  /**
   * @description for Companies supported or sponsors fro that ad
   */
  public get PaymentPlans(): IPaymentPlan[] {
    return this._adConfigService.PaymentPlans;
  }


  /**
   * get ContractType
   */
  public get ContractType(): Contract_Type {
    return this._adConfigService.ContractType
  }

  /**
   * set ContractType
   */
  private set ContractType(type: Contract_Type) {
    this._adConfigService.ContractType = type
  }

  /**
   * get ShowRent
   */
  public get ShowRent(): boolean {
    return this._adConfigService.showRent
  } 

  /**
   * 
   */
  public get PriceTitle(): string {
    return this.ShowRent ? this._adConfigService.rentalPriceTitle : this._adConfigService.salePriceTitle
  }

  /**
   * PriceType
   */
  public get PriceType(): typeof Price_Type {
    return Price_Type
  }

  /**
   * PriceValueType
   */
  public get PriceValueType(): Price_Type {
    return this._adConfigService.PriceType
  }  

  /**
   * ListOfContractType
   */
  public get ListOfContractType(): typeof ListOfContractType {
    return this._adConfigService.ListOfContractType;
  }
  
  /**
   * listOfRentType
   */
  public get listOfRentType(): typeof listOfRentType {
    return this._adConfigService.listOfRentType
  }

  /**
   * @deprecated old version of ui build ad, was hide some inputs filed if contractType is Rent,
   * Now we just disabled the filed
   */
  public get IShowOnSoomPriceType(): boolean {
    return this.ShowRent === false
  }

  /**
   * 
   */
  public get IShowStartFromPriceType(): boolean {

    /**
     * 
     */
    return this._categoryType !== CATEGOR_VALUE_TYPE.N && this._categoryType !== CATEGOR_VALUE_TYPE.LN;

  }  

  /**
   * @description check if priceType is ON_SOOM
   */
  public get IsOnSoomPrice(): boolean {
    return this._adConfigService.IsOnSoomPrice
  }

  /**
   * @description check if priceType is NORMAL
   */
  public get IsNormalPrice(): boolean {
    return this._adConfigService.IsNormalPrice
  }

  /**
   * @description check if priceType is NORMAL
   */
  public get IStartFromPrice(): boolean {
    return this._adConfigService.IStartFromPrice
  }

  /**
    * @description
    * user can't add deposit in ad if he not has MarketPlace,
    * @returns boolean value
    * @deprecated only AppOwner can Build Ad then not need MarketPlace
  */
  public get ShowDeposit() {

    // ES6 Destructuring 
    const { isMarketPlace } = this.UserInfo.value || {};

    /**
     * 
     */
    return isMarketPlace

  }
  
  /**
   * @description check enabled value
   */
  public get ShowDepositInput(): boolean {

    // ES6 Destruction
    const { enabled } = this.control('deposit');

    /**
     * check if deposit is enabled
     */
    return enabled
    
  } 

  /**
   * Current Coords
   */
  public get Coords(): google.maps.LatLngLiteral {
    return this._adConfigService.Coords
  }

  /**
   * set Current Coords
   */
  private set Coords(coords: google.maps.LatLngLiteral) {
    this._adConfigService.Coords = coords;
  }  

  /**
   * @description check if map get any coords
   */
  public get IsMapHasGetCoords(): boolean {

    /**
     * 
     */
    return this.Coords !== null;

  }

  /**
   * @description check if map not get init value from area location
   */
  public get IsMapDisabled(): boolean {

    // ES6 Destruction
    const { disabled } = this.control('location');

    /**
     * 
     */
    return disabled;

  }

  /**
   * FILE_TYPE
   */
  public get FileTypes(): typeof FILE_TYPE {
    return FILE_TYPE
  }

  /**
   * isBuilding
   */
  public get isBuilding(): boolean {

    /**
     * 
     */
    return this._adConfigService.isBuilding;

  }

  /**
   * isPlaning
   */
  public get isPlaning(): boolean {

    /**
     * 
     */
    return this._adConfigService.isPlaning;

  }

  /**
   * isVillas
   */
  public get isVillas(): boolean {

    /**
     * 
     */
    return this._adConfigService.isVillas;

  } 
  
  /**
   * isOffPlanSale
   */
  public get isOffPlanSale(): boolean {

    /**
     * 
     */
    return this._adConfigService.isOffPlanSale;

  }   
  
  /**
   * isNormal
   */
  public get isNormal(): boolean {
    
    /**
     * 
     */
    return this._adConfigService.isNormal;

  }
  
  /**
   * isLand
   */
  public get isLand(): boolean {
    
    /**
     * 
     */
    return this._adConfigService.isLand

  }  


  /**
   * @description check if current category type from types has Bundled Ads
   * @returns if BL or PL or VL return true else false
   */
  public get IsHasBundledAds(): boolean {
    return this._adConfigService.IsHasBundledAds
  } 
  

  /**
   * @description every main category type has sub type, we check in main type to get sub type or related type
   * @returns CATEGOR_VALUE_TYPE.N | CATEGOR_VALUE_TYPE.LN | CATEGOR_VALUE_TYPE.V
   */
  private get _bundleAdRelatedCategoryType(): CATEGOR_VALUE_TYPE.N | CATEGOR_VALUE_TYPE.LN | CATEGOR_VALUE_TYPE.V | CATEGOR_VALUE_TYPE.BL {

    /**
     * 
     */
    switch(this._categoryType) {
      case CATEGOR_VALUE_TYPE.BL:
        return CATEGOR_VALUE_TYPE.N;
      case CATEGOR_VALUE_TYPE.PL:
        return CATEGOR_VALUE_TYPE.LN;
      case CATEGOR_VALUE_TYPE.VL:
        return CATEGOR_VALUE_TYPE.V;
      case CATEGOR_VALUE_TYPE.OFF_PLAN:
        return CATEGOR_VALUE_TYPE.BL;        
    }    

  }

  /**
   * @description if names value is includes in DisabledControlsEligibleForSubmission, then skip push it, else push it
   */
  private set _disabledControlsEligibleForSubmission(names: string | string[]) {
    
    /**
     * 
     */
    if (names == null) return;

    /**
     * 
     */
    if (typeof names === 'string' && this.disabledControlsEligibleForSubmission.includes(names) === false) {
      this.disabledControlsEligibleForSubmission.push(names)
    }
    else if (Array.isArray(names)) {

      /**
       * 
       */
      const filter = names.filter(name => this.disabledControlsEligibleForSubmission.includes(name) === false);

      /**
       * 
       */
      this.disabledControlsEligibleForSubmission.push(...filter)

    }

  }

  /**
   * @description the message will show in ui after submit form
   */
  private get _alertMsg(): string {

    /**
     * 
     */
    if (this.isOperationCreatedMode === false) return 'تم تعديل الاعلان بشكل صحيح'

    /**
     * 
     */
    if (this.UserInfo.value.type === usersType.normalUser) return 'تم اضافة الاعلان الي قاعدة البيانات و سوف يتم عرضه  للمستخدمين بعد اتمام عملية الدفع التاليه';
    else return 'تم اضافة الاعلان بشكل صحيح'

  }  


  /**
   * Methods
   */
  
  /**
   * 
   */
  async ngOnInit() {

    // ES6 Destruction
    const { 
      banks, saleServices,
      categories, regions,
      paymentPlans, companies,
      curd, ads, rega 
    } = this._route.snapshot.data;

    /**
     * init
     */
    this._adConfigService.Init(curd);    

    /**
     * to update list we get i from route data then set it to Ad Service 
     */
    this._adConfigService.adData = ads;
    this._adConfigService.Banks = banks;
    this._adConfigService.Regions = regions;
    this._adConfigService.Companies = companies;
    this._adConfigService.Categories = categories;
    this._adConfigService.SaleServices = saleServices;
    this._adConfigService.PaymentPlans = paymentPlans;


    /**
     * init
     */
    // this._initQuestions();
    // this._initVipAdConfiguration();
    this._initBundledAdLiveSearch();
    this._observeAdvertisementType();
    this._duplicateSameValueForEnControls();

    /**
     * 
     */
    if (this.isOperationCreatedMode === false) {

      /**
       * 
       */
      if (this._route.snapshot.data?.bundledAdFullEdit === false) {

        /**
         * 
         */
        this.control('city').disable();
        this.control('area').disable();
        this.control('region').disable();
        this.control('category').disable();

        /**
         * 
         */
        this._disabledControlsEligibleForSubmission = ['city', 'area', 'region', 'category'];

      }

      /**
       * init
       */
      const data = rega ? { ...await this._convertRegaDataToSaaeiData(rega), ...ads } : ads

      /**
       * 
       */
      this._initOperationUpdateForm(data);

    } 

  };

  /**
   * 
   */
  private _initOperationUpdateForm(data: {[key: string]: any}): void {
    
    /**
     * region
     */
    if (data?.region) this.HandlerGetCitiesByRegion(data.region);

    /**city
     * 
     */
    if (data?.city) this.HandlerGetAreasByCity(data.city);

    /**
     * 
     */
    /**
     * 
    */
    // ES6 Destructing
    const { 
      area,
      floors,
      zonesCount,
      features,
      location,
      properties,
      location: { coordinates: [ lng, lat ] },
    } = data;
    
    /**
     * location
     */
    if (location) this.GetNewCoords({ lat, lng })    

    /**
     * area
     */
    if (area && location) this.HandlerGetArea({...area, location});
    
    /**
     * category
     */
    if (data?.category) {

      this
        .HandlerGetSubCategoryByMain(data.category)
        .then(_ => {

          /**
           * 
           */
          if (!this.isBuilding && !this.isPlaning) return;

          /**
           * handler zero value
           */
          if (floors < 1 && zonesCount < 1) return;
  
          // init
          const count = floors ?? zonesCount;
          const units = data.units ?? data.zones;
          const control = this.UnitsControl ?? this.ZonesControl;

          /**
           * set floors count
           */
          this.ChildrenCountHandler(count, control);
  
          // init
          let unitsMapping = [];

          if (this.isBuilding) {
            unitsMapping = units.map(floor => ({ ...floor, unit: floor.unit?.map(u => u.id)}));
          }
          else if (this.isPlaning) {
            unitsMapping = units
          }
  
          /**
           * 
           */
          for (let i = 0; i < count; i++) {

            if (this.isBuilding) {
              const floor = unitsMapping.find(u => u.floor == (i + 1));

              if (floor != null) control.at(i).get('unit').patchValue(floor.unit);

            }
            else if (this.isPlaning) {
              
              /**
               * 
               */
              control.patchValue(unitsMapping)

            }
  
          }
  
        });

    }


    /**
     * subCategory
     */
    if (data?.subCategory) {
      
      this
        .HandlerPropertiesBySubCategory(data.subCategory)
        .then(_ => {
  
          /**
           * in update mode we get data to make it init value control
           */
          const currentFeatures: any[] = features;
          const currentProperties: any[] = properties;      
          
          /**
           * start main Props
           */
          if (currentProperties.length > 0) {
  
            const currentMainValue = this.MainProperties.map(prop => {
    
              /**
               * 
               */
              const currentValue = currentProperties.find(currentProp => currentProp.id == prop.id);
    
              /**
               * 
               */
              if (currentValue != null) return { property: prop.id, value: currentValue.value }
    
              return { property: prop.id, value: null }
    
            })
  
            /**
             * 
             */
            this._adConfigService.MainPropertiesControl.setValue(currentMainValue);
  
          }
  
          /**
           * start Sub Props
           */        
          if (currentFeatures.length > 0) {
  
            /**
             * 
             */
            const mapping = currentFeatures.map(ft => ft.id);
    
            /**
             * 
             */
            const currentSubValue = this.SubProperties.map(prop => mapping.includes(prop.id) ? prop.id : null);
    
            /**
             * 
             */
            this._adConfigService.SubPropertiesControl.setValue(currentSubValue);
  
          }
  
        });

    }

    /**
     * contractType
     */
    // if (data?.contractType) this.contractToggle(data.contractType);
    
    /**
     * rentType
     */
    // if (data?.rentType) this.RentToggle(data.rentType);

    /**
     * priceType
     */
    // if (data?.priceType) this.PriceTypeToggle(data.priceType);


    /**
     * 
     */
    this.Form.patchValue({
      area: data?.area?.id,
      city: data?.city?.id,
      region: data?.region?.id,
      adNumber: data?.adNumber ?? null,
      title_en: data?.title_en ?? null,
      title_ar: data?.title_ar ?? null,
      zoneNumber: data?.zoneNumber,
      blockNumber: data?.blockNumber,
      unitNumber: data?.unitNumber ?? null,
      streetName: data?.streetName ?? null,
      address_ar: data?.address_ar ?? null,
      address_en: data?.address_en ?? null,
      licenseEndDate: data?.licenseEndDate,
      advertiserName: data?.advertiserName,
      category: data?.category?.id, 
      subCategory: data?.subCategory?.id,
      // rentType: data?.rentType,
      contractType: data?.contractType,
      // priceType: data?.priceType,
      totalPrice: data?.totalPrice,
      hasDeposit: data?.hasDeposit,
      enableInstallment: data?.enableInstallment,
      enablePhoneContact: data?.enablePhoneContact,
      deposit: data?.deposit || null,
      availableUnitsCount: data?.availableUnitsCount,
      description_ar: data?.description_ar ?? null,
      description_en: data?.description_en ?? null,
      bestFeature_ar: data?.bestFeature_ar ?? null,
      bestFeature_en: data?.bestFeature_en ?? null,
      // guarantees: data?.guarantees ?? false,
      // guaranteesDesc: data?.guaranteesDesc || null,
      // saudiBuildingCode: data?.saudiBuildingCode ?? false,
      // contraindications: data?.contraindications ?? false,
      // undocumentedRights:data?.undocumentedRights ?? false,
      // influentialInformation: data?.influentialInformation ?? false,
      // contraindicationsDesc: data?.contraindicationsDesc  || null,
      // undocumentedRightsDesc: data?.undocumentedRightsDesc  || null,
      // influentialInformationDesc: data?.influentialInformationDesc || null,      
      commissionNumber: data?.commissionNumber,
      advertiserClass: data?.advertiserClass,
      link3D: data?.link3D?.length ? data?.link3D[0] : null,
      imgs: data?.imgs,
      adsFile: data?.adsFile,
      sketch: data?.sketch,
      type: data?.type,
      contract: data?.contract,
      size: data?.size,
      floors: data?.floors,
      zonesCount: data?.zonesCount,
      qrCodeUrl: data?.qrCodeUrl,
      price: data?.price,
      company: data?.company?.id,
      paymentPlan: data?.paymentPlan?.id,
      banks: data?.banks?.map(bank => bank?.id) ?? [],
      lands: data?.lands?.map(land => land?.id) ?? [],
      buildings: data?.buildings?.map(b => b?.id) ?? [],
      villas: data?.villas?.map(villa => villa?.id) ?? [],
      services: data?.services?.map(scv => scv?.id) ?? [],
      startSaleDate: data?.startSaleDate ? formatDate(data?.startSaleDate, 'yyyy-MM-dd', 'en') : null,
    });

    /**
     * 
     */
    this.Form.markAllAsTouched();

  }

  /**
   * 
   * @param data 
   */
  public async HandlerCreationType(data: IRega | CATEGOR_VALUE_TYPE) {

    if (typeof data === 'string') {

      /**
       * 
       */
      const category = this.Categories.find(c => c.type == data);

      /**
       * 
       */
      this.HandlerGetSubCategoryByMain(category);

      /**
       * 
       */
      this.control('category').disable();
      this.control('category').setValue(category.id);

      /**
       * 
       */
      this._disabledControlsEligibleForSubmission = 'category';

    }
    else {

      /**
       * 
       */
      this.RegaMode = true;

      /**
       * 
       */
      this.FilteredCategories = this.Categories.filter(category => !this._adOperation.IsHasBundledAds(category.type))
      
      /**
       * 
       */
      const regaData = await this._convertRegaDataToSaaeiData(data);
      const fullData = {...this.Form.value, ...regaData}

      /**
       * 
       */
      this._initOperationUpdateForm(fullData);

    }
    
  }  

  /**
   * @description get rega data and compare it with saaei data then return it
   * @returns return saaei data
   */
  private async _convertRegaDataToSaaeiData(data: IRega): Promise<{[key: string]: any}> {

    /**
     * 
     */
    const convertData = {};

    /**
     * 
     * @param controlName 
     * @param value 
     */
    const _handlerDisabledAndValueControl  = (controlName: string, value: any): void => {

      /**
       * 
       */
      convertData[controlName] = value;

      /**
      * 
      */
      this.control(controlName).disable();

      /**
       * 
       */
      this._disabledControlsEligibleForSubmission = controlName;

    }

    // ES6 Destruction
    const { 
      endDate,
      adNumber,
      adLicenseUrl,
      propertyType,
      propertyArea,
      propertyPrice,
      advertiserName,
      commissionNumber,
      propertyTotalPrice,
      advertisementType,
      obligationsOnTheProperty,
      guaranteesAndTheirDuration,
      complianceWithTheSaudiBuildingCode,
      location: { region, city, district, street, buildingNumber, latitude, longitude, } 
    } = data;

    /**
     * 
     */
    convertData['adNumber'] = adNumber;
    convertData['qrCodeUrl'] = adLicenseUrl;
    convertData['licenseEndDate'] = endDate;
    convertData['unitNumber'] = buildingNumber;
    convertData['totalPrice'] = propertyTotalPrice;
    convertData['advertiserName'] = advertiserName;
    convertData['commissionNumber'] = commissionNumber;
    convertData['location'] = { coordinates: [ longitude, latitude ] } ;

    /**
     * propertyPrice
     */
    if (propertyPrice) _handlerDisabledAndValueControl('price', propertyPrice);

    /**
     * propertyArea
     */
    if (propertyArea) _handlerDisabledAndValueControl('size', propertyArea);

    /**
     * street
     */
    if (street) _handlerDisabledAndValueControl('streetName', street);

    /**
     * complianceWithTheSaudiBuildingCode
     */
    // if (complianceWithTheSaudiBuildingCode) _handlerDisabledAndValueControl('saudiBuildingCode', complianceWithTheSaudiBuildingCode);

    /**
     * guaranteesAndTheirDuration
     */
    // if (guaranteesAndTheirDuration) {
    //   _handlerDisabledAndValueControl('guarantees', true);
    //   _handlerDisabledAndValueControl('guaranteesDesc', guaranteesAndTheirDuration);
    // }

    /**
     * obligationsOnTheProperty
     */
    // if (obligationsOnTheProperty) {
    //   _handlerDisabledAndValueControl('contraindications', true);
    //   _handlerDisabledAndValueControl('contraindicationsDesc', obligationsOnTheProperty);
    // }    


    /**
     * advertisementType
     */
    if (advertisementType) {

      /**
       * 
       */
      // const value = advertisementType == 'إيجار' ? Contract_Type.RT : Contract_Type.SE;

      /**
       * 
       */
      // _handlerDisabledAndValueControl('contractType', value)

    }

    /**
     * region
     */
    if (region) {
      /**
       * 
       */
      const regionObject = this.Regions.find(reg => (reg.regionName as string).includes(region));

      /**
       * 
       */
      if (regionObject) {

        /**
         * 
         */
        _handlerDisabledAndValueControl('region', regionObject);

        /**
         * city
         */
        if (city) {
          
          /**
           * 
          */
          if (!Array.isArray(this.Cities) || this.Cities.length == 0) {
            
            /**
             * 
             */
            await this.HandlerGetCitiesByRegion(regionObject);
  
          }
  
          /**
           * 
           */
          const cityObject = this.Cities?.find(c => (c?.cityName as string).includes(city));
  
          /**
           * 
           */
          if (cityObject) {
  
            /**
             * 
             */
            _handlerDisabledAndValueControl('city', cityObject); 
  
            /**
             * district
             */
            if (district) {
    
              /**
               * 
              */
              if (!Array.isArray(this.Areas) || this.Areas.length == 0) {

                /**
                 * 
                 */
                await this.HandlerGetAreasByCity(cityObject);
    
              }
    
              /**
               * 
               */
              const areaObject = this.Areas?.find(a => (a?.areaName as string).includes(district));
    
              /**
               * 
               */
              if (areaObject) _handlerDisabledAndValueControl('area', areaObject);
        
            }
  
          }
  
        }

      }

    }

    
    /**
     * 
     */
    if (propertyType) {

      /**
       * 
       */
      const child = this.Categories.map(category => category.child).flat();

      /**
       * 
       */
      const subValue = child.find(s => ((s as ICategory).categoryName as string).includes(propertyType));
      
      /**
       * 
       */
      if (subValue) _handlerDisabledAndValueControl('subCategory', subValue);      
      
      /**
       * 
       */
      if (subValue) {

        /**
         * 
         */
        const mainValue = this.Categories.find(c => c?.id == (subValue as ICategory)?.parent);

        /**
         * 
         */
        if (mainValue) _handlerDisabledAndValueControl('category', mainValue);

      }

    }

    /**
     * 
     */
    return convertData;

  }  

  /**
   * 
   */
  private _observeAdvertisementType(): void {

    this.control('type')
      .valueChanges
      .pipe(
        takeUntil(this._destroy$),
        filter(_ => !this.IsHasBundledAds),
        tap(_ => {
          
          /**
           * init
           */
          const hasDeposit = this.control('hasDeposit');
          const isOffPlanSale = this._advertisementType === ADVERTISEMENT_TYPE.offPlanSale

          // ES6 Destruction
          // const { value } = hasDeposit;

          
          /**
           * 
          */
          if (isOffPlanSale) {
           
            /**
             * add Validator
             */
            this.control('paymentPlan').addValidators(OverrideValidators.required);


          }
          else {

            /**
             * remove Validator
             */
            this.control('paymentPlan').removeValidators(OverrideValidators.required);

          }

          /**
          * checked hasDeposit by true
          */
          hasDeposit.patchValue(isOffPlanSale)

          /**
          * enable/disable deposit value & show it
          */
          this.ToggleDisableDepositField(isOffPlanSale)

          /**
           * enable/disable payment inputs
           */
          this.TogglePaymentInputs(isOffPlanSale);

          /**
           * 
           */
          this.control('paymentPlan').updateValueAndValidity();
          
          /**
           * update current CategoryType in maxDeposit
           */
          this.Form.addValidators(AdsValidators.maxDeposit(this._categoryType));
          this.Form.updateValueAndValidity()

        }),
      )
      .subscribe()

  }


  /**
   * @description we have fields have values ​​in Arabic and we also have the same fields but in English so pass them the same value in Arabic
   * if you have any question, don't ask me just ask back-end
   */
  private _duplicateSameValueForEnControls(): void {

    /**
     * 
     * @param controlName controlName to set same value from other control
     * @param value 
     */
    const setValue = (controlName: string, value: string) => {
      this.control(controlName).setValue(value)
    }

    /**
     * 
     */
    const controls = [
      this.control('title_ar').valueChanges
      .pipe(map(value => ({ sameControlNameEn: 'title_en', value }))),
      this.control('address_ar').valueChanges
      .pipe(map(value => ({ sameControlNameEn: 'address_en', value }))),
      this.control('description_ar').valueChanges
      .pipe(map(value => ({ sameControlNameEn: 'description_en', value }))),
      this.control('bestFeature_ar').valueChanges
      .pipe(map(value => ({ sameControlNameEn: 'bestFeature_en', value })))                  
    ]

    /**
     * merge Observables in one
     */
    merge(...controls)
      .pipe(takeUntil(this._destroy$))
      .subscribe(res => setValue(res.sameControlNameEn, res.value));

  }

  /**
   * @description we have questions with yes or no, and if the choice is yes, the field for this question must be filled in.
   */
  private _initQuestions(): void {

    /**
     * 
     * @param reflectControlName The name of the field that is relied upon to change its state.
     * @param checked if true enable textArea control, else disable it
     */
    const toggle = (reflectControlName: string, checked: boolean) => {

      // ES6 Destruction
      const { disabled } = this.control(reflectControlName);

      /**
       * if reflectControlName not available for user interactive, stop func logic
       */
      if (disabled === true) return null;

      /**
       * get textArea control
       */
      const controlName = reflectControlName + 'Desc';


      /**
       * 
       */
      if (checked === true) this.control(controlName).enable();
      else this.control(controlName).disable();

    };

    /**
     * 
     */
    const controls = [
      this.control('contraindications').valueChanges
      .pipe(map(checked => ({ reflectControlName: 'contraindications', checked }))),
      this.control('undocumentedRights').valueChanges
      .pipe(map(checked => ({ reflectControlName: 'undocumentedRights', checked }))),
      this.control('influentialInformation').valueChanges
      .pipe(map(checked => ({ reflectControlName: 'influentialInformation', checked }))),
      this.control('guarantees').valueChanges
      .pipe(map(checked => ({ reflectControlName: 'guarantees', checked })))                  
    ]

    /**
     * merge Observables in one
     */
    merge(...controls)
      .pipe(takeUntil(this._destroy$))
      .subscribe(v => toggle(v.reflectControlName, v.checked));

  }
  

  /**
   * init vip ad
   */
  private _initVipAdConfiguration(): void {

    /**
     * adding banks & services controls
     * vip ad has some extra controls, like as bank financing and others.
     */
    this.Form.addControl('banks', this._fb.control([]));
    this.Form.addControl('services', this._fb.control([]));

    /**
     * mark ad as vip
     */
    this.Form.addControl('specialAdvertisement', this._fb.control(true));

    /**
     * remove rent
     */
    this._adConfigService.ListOfContractType = [ListOfContractType[0]];

  }

  /**
   * _initBundledAdLiveSearch
   */
  private _initBundledAdLiveSearch(): void {

    /**
     * 
     */
    if (this.IsHasBundledAds) {
      this.control('units').reset();
      this.control('villas').reset();
      this.control('buildings').reset();
      this._adConfigService.Units = [];
      this._adConfigService.Villas = [];
      this._adConfigService.Buildings = [];
    }

    /**
     * 
     */
    const controls = [
      this.control('city').valueChanges,
      this.control('area').valueChanges,
      this.control('category').valueChanges,
      this.control('type').valueChanges.pipe(startWith(this._advertisementType)),
      // this.control('contractType').valueChanges,
      // this.control('rentType').valueChanges,
    ];     

    /**
     * 
     */
    combineLatest(controls).pipe(
      takeUntil(this._destroy$),
      delay(100),
      debounceTime(100),
      filter(_ => this.IsHasBundledAds === true),
      map(values => {

        // ES6 Detraction
        const [city, area, category, type] = values;

        /**
         * 
         */
        return { city, area, category, type};

      }),
      filter((ctr) => {

        // ES6 Destruction
        const { city, area, category } = ctr;

        /**
         * get controls without rentType
         */
        const allControlsIsValid = [city, area, category].every(value => value !== null && value !== undefined);

        /**
         * 
         */
        // if (allControlsIsValid === true && contractType === Contract_Type.SE) return true;
        // else if (contractType === Contract_Type.RT && rentType != null) return true;

        /**
         * 
         */
        return allControlsIsValid

      }),
      map(values => {    

        /**
         * only return key has value
         */
        return Object.entries(values).reduce((acc, [key, value]) => {
          if (value != null) acc[key] = value;
          return acc;
        },{})

      })
    ).subscribe(this._handlerResultBundledAdLiveSearch.bind(this));

  }


  /**
   * @description handler liverSearch Params with others, then pass it api liverSearch
   * @param params for liveSearch
   */
  private _handlerResultBundledAdLiveSearch(params: Params): void {

    console.log('api liveSearch is called');

    /**
     * 
     */
    this.isLoadingLiveSearch = true;    
    
    /**
     * handler params
     */
    const Params = {
      ...params,
      related: false,
      [RANDOM_VALUE.loader]: true,
      owner: this._g.CorrectUserId,
      categoryType: this._bundleAdRelatedCategoryType,
    }

    /**
     * i don't know why i delete it but back-end very lazy to fix it
     */
    delete Params['category']

    /**
     * here like above trash code, because back-end very lazy to fix it
     */
    if (this.isOperationCreatedMode === false) {

      /**
       * 
       */
      Params['id'] = this._adData.id;

      /**
       * 
       */
      delete Params['related'];
    }

    /**
     * 
     */
    this
      ._api
      .liveSearch({params: Params})
      .subscribe(
        (res: any[]) => {

          if (this.isBuilding) {
            this.filteredUnits$.next(res);
            this._adConfigService.Units = res;
          }
          else if (this.isPlaning) {
            this.filteredUnits$.next(res);
            this._adConfigService.Lands = res;
          }
          else if (this.isVillas) this._adConfigService.Villas = res;
          else if (this.isOffPlanSale) this._adConfigService.Buildings = res;

  
          /**
           * 
           */
          this.isLoadingLiveSearch = false;
        },
        err => this.isLoadingLiveSearch = false
      );

  }

  /**
   * 
   * @param controlName name of control
   * @returns AbstractControl | null
   */
  public control(controlName: string): AbstractControl {
    return this._adConfigService.control(controlName)
  } 
  
  /**
   * HandlerGetCitiesByRegion
   */
  public async HandlerGetCitiesByRegion(region: IRegion) {

    return this._adConfigService.HandlerGetCitiesByRegion(region)

  }

  /**
   * HandlerGetAreasByCity
   */
  public async HandlerGetAreasByCity(city: ICity) {
    
    return this._adConfigService.HandlerGetAreasByCity(city)

  }

  /**
   * HandlerGetArea
   */
  public HandlerGetArea(area: IArea): void {

    // ES6 Destruction & Nested
    const { location: { coordinates: [ lng, lat ] } } = area;

    /**
     * 
     */
    this.MapCoords = { lat, lng };

    
    /**
     * 
     */
    this._adConfigService.HandlerGetArea(area)

  }

  /**
   * HandlerGetSubCategoryByMain
   */
  public async HandlerGetSubCategoryByMain(category: ICategory) {

    /**
     * 
     */
    this._adConfigService.HandlerGetSubCategoryByMain(category);

    /**
     * 
     */
    this.TogglePaymentInputs(!(this.IsHasBundledAds || this._advertisementType === ADVERTISEMENT_TYPE.Ready))

    /**
     * 
     */
    this.Form.updateValueAndValidity();

    /**
     * 
     */
    return this._initAdTypeExtraControls()


  }

  /**
   * @description if ad not Normal type, so some ad types need extra form controls
   */
  private async _initAdTypeExtraControls() {

    return new Promise<void>((resolve, reject) => {

      /**
       * remove all extra controls,
       */
      this.Form.removeControl('totalPrice');
      this.Form.removeControl('zoneNumber');
      this.Form.removeControl('blockNumber');
  
      /**
       * 
       */
      if (this.IsHasBundledAds === true) {
        this.Form.addControl('startSaleDate', this._fb.control(null, OverrideValidators.required))
      }    
  
      /**
       * add extra controls for each ad type
       */
      if (this.isBuilding === true) {
  
        /**
         * 
         */
        this.Form.addControl('units', this._fb.array([], OverrideValidators.required));
        this.Form.addControl('floors', this._fb.control(null, OverrideValidators.required));
  
        /**
         * 
         */
        this._filteredUnits(this.UnitsControl);
        
      }
      else if (this.isPlaning === true) {
        this.Form.addControl('totalPrice', this._fb.control(null))
        this.Form.addControl('zones', this._fb.array([], OverrideValidators.required));
        this.Form.addControl('zonesCount', this._fb.control(null, OverrideValidators.required));
        this.Form.addControl('lands', this._fb.control([], { nonNullable: true}))

        /**
         * 
         */
        this._filteredUnits(this.ZonesControl);
                
      }
      else if (this.isVillas === true) {
        this.Form.addControl('villas', this._fb.control([], { nonNullable: true, validators: OverrideValidators.required }))
      }
      else if (this.isOffPlanSale === true) {
        this.Form.addControl('buildings', this._fb.control([], { nonNullable: true, validators: OverrideValidators.required }))
      }      
      else if (this.isLand === true) {
        this.Form.addControl('totalPrice', this._fb.control(null))
        this.Form.addControl('zoneNumber', this._fb.control(null))
        this.Form.setControl('blockNumber', this._fb.control(null))
      }

      /**
       * 
       */
      resolve();

    });

  }

  /**
   * 
   */
  public ChildrenCountHandler(count: number, control: FormArray<FormGroup>) {
    
    /**
     * handler nullable value
     */
    if (count == null && count <= 0) {
      new Error("arg count is null")
      return;
    }

    /**
     * handler nullable value
     */
    if (control == null) {
      new Error("arg control is null")
      return;
    }

    /**
     * clear fromArray to fill it again
     */
    if (control.controls.length > 0) control.clear();

    /**
     * 
     */
    for (let i = 0; i < count; i++) {

      // init
      let g = null;

      /**
       * pass group config
       */
      if (this.isBuilding) {
        g = this._fb.group({
          unit: [null],
          floor: [i + 1, { nonNullable: true }],
        });
      }
      else if (this.isPlaning) {
        g = this._fb.group({
          lands: [null, OverrideValidators.required],
          name: [null, OverrideValidators.required],
          averagePrice: [null, OverrideValidators.required]
        });
      }

      /**
       * 
       */
      control.push(g);

    };

  }

  /**
   * @description All units selected on each floor are filtered to be only on a specific floor.
   */
  private _filteredUnits(control: FormArray<FormGroup>): void {

    /**
     * 
     */
    combineLatest([control.valueChanges, this.filteredUnits$.pipe(take(1))])
      .pipe(
        debounceTime(100),
        takeUntil(this._destroy$),
        map(res => {
          
          // ES6 Destruction
          let [ units ] = res;

          // init
          let src = [];
          let f: any[] = [];

          /**
           * filter units then return not selected
           */
          if (this.isBuilding) {
            src = this.Units;
            units = units.flatMap(floor => floor?.unit).filter(u => u != null);
            f = src?.filter(u => !units.includes(u?.id));
          }
          else if (this.isPlaning) {
            src = this.Lands;
            units = units.flatMap(zone => zone?.lands).filter(l => l != null);
            f = src?.filter(u => !units.includes(u?.id));
          }

          /**
           * 
           */
          return units.length > 0 ? f : src;
  
        }),
      ).subscribe(res => this.filteredUnits$.next(res));

  }  

  /**
   * HandlerPropertiesBySubCategory
   */
  public async HandlerPropertiesBySubCategory(subCategory: ICategory) {

    return this._adConfigService.HandlerPropertiesBySubCategory(subCategory)

  }

  /**
   * 
   * @param status boolean value
   * @description if true enable controls, then disable it's 
   */
  public TogglePaymentInputs(status: boolean) {

    const contract = this.control('contract');
    const paymentPlan = this.control('paymentPlan');

    if (!status) {
      contract.disable();
      paymentPlan.disable();
    }
    else {
      contract.enable();
      paymentPlan.enable();
    }

  }  

  /**
   * @description planing & villas & vip ad not have available to rent only sale
   * if user has any value of those then contractType only will be SALE & the rent will removed from it
   * else the behavior will back to default with sale & rent
   */
  private _contractTypesLimitation(): void {

    /**
     * planing & villas & vip ad not have available to rent only sale
     */
    if (this.isPlaning || this.isVillas) {

      /**
       * remove rent from list
       */
      this._adConfigService.ListOfContractType = [ListOfContractType[0]];

      /**
       * handler Contract_Type.SE as default and only value user can access it
       */
      if (this.ContractType === Contract_Type.RT) {
        this.contractToggle(Contract_Type.SE);
        this.control('contractType').setValue(Contract_Type.SE);
      }

    }
    else if (this._adConfigService.ListOfContractType.length < 2) {

      /**
       * reset current value to make user very sure to select new value
       */
      this.control('contractType').reset(null);

      /**
       * make all list available to user
       */
      this._adConfigService.ListOfContractType = ListOfContractType;

    }


  }
  
  /**
   * 
   * @param type 
   */
  public contractToggle(type: Contract_Type) {
    
    /**
     * update ContractType
     */
    this.ContractType = type;

    /**
     * 
     */
    if (type == Contract_Type.RT) {

      /**
       * disable controls
       */
      // this.control('priceType').disable();
      this.control('hasDeposit').disable();
      this.control('enableInstallment').disable();

      /**
       * disable deposit value
       */
      this.ToggleDisableDepositField(false);

      /**
       * 
       */
      // this.control('rentType').setValidators(Validators.required);
      // this.control('rentType').updateValueAndValidity();
    }
    else {

      /**
       * 
       */
      // this.control('rentType').reset(null);
      // this.control('rentType').removeValidators(Validators.required);
      // this.control('rentType').updateValueAndValidity();

      /**
       * enable deposit value
       */
      this.ToggleDisableDepositField(true);      

      /**
       * enable deposit value
       */
      // this.control('priceType').enable();
      this.control('hasDeposit').enable();        
      this.control('enableInstallment').enable();
    }

  } 
  
  /**
   * 
   * @param type Rent_Type
   */
  public RentToggle(type: Rent_Type): void {
    
    /**
     * 
     */
    this._adConfigService.RentType = type;

  }

  /**
   * 
   * @param type 
   * @deprecated PriceType not available now it's default Normal or null
   */
  public PriceTypeToggle(type: Price_Type | null): void {
    
    /**
     * 
     */
    this._adConfigService.PriceTypeToggle(type);
    
  }

  /**
   * 
   * @param checked 
   */
  public ToggleDisableDepositField(checked: boolean) {

    // ES6 Destruction
    const { disabled } = this.control('deposit');
    const { enabled, value: hasDepositValue } = this.control('hasDeposit');
    
    /**
     * 
     */
    if (checked && hasDepositValue && enabled) {
      if (disabled === true) this.control('deposit').enable();
    }
    else this.control('deposit').disable();

    /**
     * 
     */
    this.control('deposit').markAsTouched()

  }
  
  /**
   * 
   */
  public ShowPopupMap(): void {

    // ES6 Destruction
    const { value } = this.control('location');

    /**
     * 
     */
    if (this.IsMapDisabled !== true || value !== null) {

      /**
       * show
       */
      this.PopupMap = true;
      
      
    }

  }


  /**
   * 
   */
  public HidePopupMap(): void {

    /**
     * 
     */
    this.PopupMap = false;
    
  }


  /**
   * @description save last center coords, because if user close & open map to much
   */
  public MapCenterCoords(): void {

    // ES6 Destruction
    const { lat, lng } = this.Map.getCenter();

    /**
     * save lasted center coords to be center map
     */
    this.MapCoords = { lat: lat(), lng: lng() };

  }


  /**
   * 
   * @param m 
   */
  public GetNewCoords(m: {[key: string]: any}) {
    
    // ES6 Destructuring 
    let { lat, lng } = m || {};
    
    /**
     * 
     */
    if (lat instanceof Function && lng instanceof Function) {
      lat = lat()
      lng = lng()
    }

    /**
     * 
     */
    this.GetGeocoder(lat, lng);

    /**
     * 
     */
    this.Coords = { lat, lng }

  }

  /**
   * 
   * @param lat 
   * @param lng 
   */
  public GetGeocoder(lat: number, lng: number) {

    /**
     * 
     */
    this.isLoadingGeocoder = true;

    /**
     * 
     */
    this._geocoder
    .geocode({ location: { lat, lng }, language: 'ar' })
    .subscribe(({results, status}) => {

      /**
       * 
       */
      if (status === google.maps.GeocoderStatus.OK) {
        
        // ES6 Destruction
        const [ result ] = results;

        /**
         * 
         */
        this.CurrentMapAddress = result ? result.formatted_address : 'لا يوجد اسم لي هذا المكان';

      } 
      else this.CurrentMapAddress = 'حدث عطل في تحديد اسم المكان';


      /**
       * 
       */
      this.isLoadingGeocoder = false;

    })

  }


  /**
   * @description because we need user not use ui control we disabled it, 
   * but that mean we cant access it from value From, so we will enabled controls before catch any value Form,
   * then back it again to disabled
   * @param state if true, enabled controls, else disabled controls
   */
  private _handlerDisabledControlsAsToggleShot(state: boolean): void {

    /**
     * 
     */
    this
      .disabledControlsEligibleForSubmission
      .forEach(name => state ? this.control(name).enable({ emitEvent: false }) : this.control(name).disable({ emitEvent: false }));

  }

  /**
   * 
   */
  public forward(): void {

    /**
     * 
     */
    this._g.goTo_TopPage();


    /**
     * 
     */
    this.simulationLoading(true);

    /**
     * enables controls
     */
    this._handlerDisabledControlsAsToggleShot(true);

    /**
     * 
     */
    setTimeout(() => {

      /**
       * 
       */
      this._adConfigService.HandlerPreviewCurrentFormData();
    }, 100)

  }

  /**
   * 
   */
  public backward(): void {

    /**
     * 
     */
    this.ErrorsResponse = null;

    /**
     * 
     */
    this._g.goTo_TopPage();

    /**
     * 
     */
    this.simulationLoading(true);

    /**
     * disabled controls
     */
    this._handlerDisabledControlsAsToggleShot(false);    

    /**
     * 
     */
    setTimeout(() => {

      /**
       * 
       */
      this._adConfigService.PreviewCurrentFormData = null;    
    }, 100)


  }

  /**
   * 
   * @param state 
   */
  public simulationLoading(state: boolean) {

    /**
     * 
     */
    this._loader.setLoading(state, RANDOM_VALUE.loader)

    /**
     * 
     */
    setTimeout(() => {
      this._loader.setLoading(!state, RANDOM_VALUE.loader)
    }, 500);

  }  

  /**
   * 
   * @param adId adId for navigate to details page 
   */
  private _alertSubmit(advertisement?: number) {
    
    /**
     * 
     */
    if (this.UserInfo.value.type !== usersType.normalUser) this._router.navigate(['realty-management', 'view-realty-advertisement', advertisement]);
    else if (this.isOperationCreatedMode === true) {

      // ES6 Destruction
      const {  tax, cost, total } = this.BillInfo;
  
      /**
       * 
       */
      this.MetaData = {
        tax,
        cost,
        total,
        advertisement,
        type: PAYMENT_TYPE.ads,
        client: this.UserInfo.value.id,
        description: 'اضافة اعلان من المستخدم العادي يتم دفع سعر الاعلان لكي يتم عرضه'
      }
  
      /**
       * 
       */
      this.NavigateToTapPayment = true;

    }

  }  

  /**
   * 
   */
  public submit(): void {

    /**
     * 
     */
    if (this.Form.valid === false) return null;

    /**
     * 
     */
    this._adConfigService.IsLoading = true;

    /**
     * 
     */
    const _formData = this.Form.value;

    /**
     * 
     */
    for (const key in _formData) {

      /**
       * 
       */
      if (_formData[key] === null) delete _formData[key];

      /**
       * 
       */
      switch (key) {
        case 'contractType':
          // if (_formData[key] === Contract_Type.RT) _formData['priceType'] = Price_Type.normal;
          break
        case 'size':
        case 'price':
        case 'deposit':
        case 'totalPrice':
          _formData[key] = parseFloat(_formData[key]?.toString()?.replace(/,/g, ''));
            break;
        case 'properties':
          _formData[key] = (_formData[key] as any[]).filter(prop => prop.value != null);
          break; 
        case 'features':
          _formData[key] = (_formData[key] as any[]).filter(f => f != null);
          break;                      
        case 'title_ar':
        case 'title_ar':    
          
          /**
           * so this trash code here because back-end very lazy to do it from his side
           */
          const contractType = _formData['contractType'];
          const subCategory = this.SubCatagories.find(s => s.id === _formData['subCategory']);

          /**
           * 
           */
          _formData['title_en'] = `${subCategory.categoryName_en} ${contractType == Contract_Type.SE ? 'Sale' : 'Rent'}`;
          _formData['title_ar'] = `${subCategory.categoryName_ar} ${contractType == Contract_Type.SE ? 'للبيع' : 'للايجار'}`;

          break;
        case 'zones':
          /**
           * 
           */
          const zones = this.ZonesControl.value as any[];

          _formData[key] = zones.map(zone => ({...zone, averagePrice: parseFloat(zone.averagePrice?.toString()?.replace(/,/g, ''))}))
          _formData['lands'] = (this.ZonesControl.value as any[]).flatMap(zone => zone.lands)

          break;
        case 'lands':
        case 'villas':
        case 'units':
          
          /**
           * all this is trash code and i think you know why XD
           * only update oldData in update mode
           */
          if (this.isOperationCreatedMode === true) break;

          /**
           * 
           */
          _formData['availableUnitsCount'] = _formData[key]?.length;          

          if (key === 'lands') {
            _formData['oldLands'] = (this._adData.lands as any[]).filter(land => _formData[key]?.includes(land.id) === false).map(land => land.id);
          }
          else if (key === 'villas') {
            _formData['oldVillas'] = (this._adData.villas as any[]).filter(villa => _formData[key]?.includes(villa.id) === false).map(villa => villa.id);
          }
          else if (key === 'units') {
            _formData['oldUnits'] = (this._adData.units as any[]).flatMap(floor => floor?.unit).filter(unit => _formData[key]?.includes(unit?.id) === false).map(unit => unit.id);
          }

          break;
      }

    }
    
    /**
     * call http api request
     */
    this._httpRequest(_formData)

  }

  /**
   * 
   * @param formData 
   */
  private _httpRequest(formData: IAdvertisementOperation): void {

    /**
     * 
     * @param res 
     */
    const res = (res: any) => {

      /**
       * 
       */
      this.ResponseAdData = res;

      /**
       * 
       */
      this._alert.show({
        titleBtn: 'موافق',
        msg: this._alertMsg,
        type: LAYOUTS_TYPE.alertSucess,
        callback: () => {
          this._alert.hide();
          this._alertSubmit(res?.id || this._adData?.id);
        },
      })

      /**
       * 
       */
      this.IsLoading = false;
      
    }

    /**
     * 
     * @param err 
     */
    const err = (err: HttpErrorResponse) => {

      // ES6 Destructuring
      const { error: { errors } } = new HttpErrorResponseHandler(err);
      
      /**
       * 
       */
      this.ErrorsResponse = errors;

      /**
       * 
       */
      this.IsLoading = false;        

    }
    
    /**
     * 
     */
    if (this.isOperationCreatedMode === true) this._api.createAds(formData).subscribe(res, err);
    else this._api.editAds(this._adData.id, formData).subscribe(res, err);    

  }

  /**
   * 
   */
  ngOnDestroy(): void {

    /**
     * destroy all subscriptions in component
     */
    this._destroy$.next();
    this._destroy$.complete();    

    /**
     * destroy _adConfigService
     */
    this._adConfigService.OnDestroy();
  }

}
